import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import moment from "moment"
import DateRangePicker from "react-bootstrap-daterangepicker"
import { compareStatus, getPayload, updateDates, updateCompareDates } from "actions"

var BS = require("react-bootstrap")

class DatePicker extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	handleEvent = (event, picker) => {
		var dates = {
			startDate: picker.startDate,
			endDate: picker.endDate,
			ytd: false,
		}
		if (picker.chosenLabel == "This Year") dates.ytd = true
		localStorage.setItem("currentDates", JSON.stringify(dates))
		this.props.updateDates(picker)
		this.props.getPayload()
	}

	ranges = () => {
		let ranges = {}
		if (this.props.years) {
			let years = []
			let currentYear = moment().year()
			for (let i = currentYear - 10; i <= currentYear; i++) {
				years.push(i)
			}
			_.forEach(years, (v) => {
				// If current year, set the end time to now instead of December 31 - projections
				if (v == moment().year()) ranges[v] = [moment().year(v).startOf("year"), moment()]
				else ranges[v] = [moment().year(v).startOf("year"), moment().year(v).endOf("year")]
			})
		} else if (this.props.custom) {
			ranges = {}
		} 
		else if(this.props.quarters) {
			for(let i = 1; i <= 10; i++) {
				let label = moment().startOf("quarter").subtract(i, "quarter").format("[Q]Q Y")
				ranges[label] = [
					moment().startOf("quarter").subtract(i, "quarter"),
					moment().startOf("quarter").subtract(i, "quarter").endOf("quarter"),
				]
			}
		}
		else {
			ranges = {
				Today: [moment().startOf("day"), moment().endOf("day")],
				"Last 7 Days": [moment().subtract(6, "days"), moment()],
				"Last 30 Days": [moment().subtract(29, "days"), moment()],
				"This Month": [moment().startOf("month"), moment().endOf("month")],
				"Last Month": [
					moment().subtract(1, "month").startOf("month"),
					moment().subtract(1, "month").endOf("month"),
				],
				"Last Year": [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")],
				"Past 6 Months": [moment().subtract(6, "months"), moment()],
				"Past Year": [moment().subtract(1, "years"), moment()],
				"This Year": [moment().startOf("year"), moment()],
				"Past 2 Years": [moment().subtract(2, "years"), moment()],
				"Past 3 Years": [moment().subtract(3, "years"), moment()],
				[moment().startOf("quarter").format("[Q]Q Y")]: [moment().startOf("quarter"), moment()],
				[moment().startOf("quarter").subtract(1, "quarter").format("[Q]Q Y")]: [
					moment().startOf("quarter").subtract(1, "quarter"),
					moment().startOf("quarter").subtract(1, "quarter").endOf("quarter"),
				],
				[moment().startOf("quarter").subtract(2, "quarter").format("[Q]Q Y")]: [
					moment().startOf("quarter").subtract(2, "quarter"),
					moment().startOf("quarter").subtract(2, "quarter").endOf("quarter"),
				],
				[moment().startOf("quarter").subtract(3, "quarter").format("[Q]Q Y")]: [
					moment().startOf("quarter").subtract(3, "quarter"),
					moment().startOf("quarter").subtract(3, "quarter").endOf("quarter"),
				],
				"All Time": [moment().subtract(30, "years"), moment()],
			}
		}
		return ranges
	}

	initSettings = () => {
		return {
			startDate: this.props.dates.start,
			endDate: this.props.dates.end,
			ranges: this.ranges(),
			singleDatePicker: this.props.custom,
			//showCustomRangeLabel: this.props.years ? false : true}
			showCustomRangeLabel:
				this.props.years && moment().startOf("year").unix() !== this.props.dates.startStamp ? false : true,
			opens: "left",
		}
	}

	render() {
		//console.log(this.props.dates)
		var label = this.props.dates.startText + " - " + this.props.dates.endText
		let compareLabel
		if (this.props.cDates.startText) {
			compareLabel = `Comparing to ` + this.props.cDates.startText + " - " + this.props.cDates.endText
		} else {
			compareLabel = "Choose Comparison Dates"
		}
		if (this.props.cDates.start.valueOf() < 0) {
			compareLabel = "Comparing to All Time"
		}
		if (this.props.dates.startText === this.props.dates.endText) {
			label = this.props.dates.startText
		} else if (this.props.dates.start.valueOf() < 0) {
			label = "All Time"
		}
		var compareText = this.props.currentCompareStatus ? "Remove Comparison" : "Compare Dates"
		return (
			<div className="title__datePicker">
				<div>
					<DateRangePicker initialSettings={this.initSettings()} onApply={this.handleEvent}>
						<div className="react-bootstrap-daterangepicker-container">
							<button type="button" className="selected-date-range-btn btn btn-default" style={{}}>
								<div className="pull-right">
									<span className="title__pickerTitleCurrent">{label}</span>
									{/* <span className={classes}>{compareLabel}</span> */}
								</div>
							</button>
						</div>
					</DateRangePicker>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		dates: state.currentDates,
		cDates: state.compareDates,
		currentCompareStatus: state.compareStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			compareStatus,
			getPayload,
			updateDates,
			updateCompareDates,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(DatePicker)
